// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2tEV9","badges":"styles_badges__15f3Q"};